var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HeadingButtons',{scopedSlots:_vm._u([{key:"heading",fn:function(){return [_c('h2',[_vm._v("All Time Stats")])]},proxy:true},{key:"buttons",fn:function(){return [_c('BaseButtonRefresh',{attrs:{"action":"stats/fetch","context":"stats"}})]},proxy:true}])}),_c('BaseCard',{attrs:{"grow":true}},[_c('BarChart',{attrs:{"rows":_vm.rows}}),_c('BaseStats',{attrs:{"stats":[
        {
          value: _vm.stats.cmd_set,
          label: 'set cmds',
          small: true,
        },
        {
          value: _vm.stats.cmd_flush,
          label: 'flush cmds',
          small: true,
        } ]}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }